import { MoneyBack } from 'fitify-ui-onboarding/src/components/Paywall/MoneyBack/MoneyBack'
import { Segment } from 'fitify-ui-onboarding/src/components/Paywall/Segment/Segment'
import { useTranslation } from 'next-i18next/pages'

import { CHECKOUT_CARDS_IMAGES } from 'sections/subscription/MoneyBackGuarantee.Utils'
import { getImageProps } from 'utils/images'

export const MoneyBackGuarantee = () => {
  const { t } = useTranslation()
  return (
    <Segment title={t('paywall_guarantee_title')}>
      <MoneyBack
        cardsImages={CHECKOUT_CARDS_IMAGES}
        cardsTitle={t('paywall_guaranteed_safe_checkout')}
        moneyBackDescription={t('paywall_guarantee_message')}
        moneyBackImage={getImageProps('shared', 'subscription', 'moneyBack')}
      />
    </Segment>
  )
}
